import { NoteTypeGroup } from "../models/app/userTypePermittedNoteTypes.model";
export var EMPTY_NOTE_GROUP_INDEX = new Map();
export var buildNoteGroupIndex = function (entries) {
    var index = new Map();
    entries === null || entries === void 0 ? void 0 : entries.forEach(function (entry) {
        var _a;
        var value = (_a = entry.value) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        if (!value || !entry.group)
            return;
        index.set(value, entry.group);
    });
    return index;
};
/**
 * The department group of a single note, or undefined when it cannot be placed.
 *
 * - A note with neither field set is unclassified. Those are readable by every user type, which is
 *   exactly what GENERAL means, so they are reported as GENERAL rather than left blank.
 * - A note whose classification is not in the catalogue returns undefined. These are the values a
 *   property typed into its own PMS and that nobody has grouped yet; guessing a department for one
 *   would put a wrong badge on the note, which is worse than putting none.
 * - `noteType` wins over `name` when both are set and disagree — it is the field the connectors
 *   that classify deliberately use, while `name` is often copied through verbatim.
 */
export var resolveNoteGroup = function (note, index) {
    var _a, _b;
    if (!note)
        return undefined;
    var noteType = (_a = note.noteType) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
    var name = (_b = note.name) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
    if (!noteType && !name)
        return NoteTypeGroup.GENERAL;
    if (noteType) {
        var group = index.get(noteType);
        if (group)
            return group;
    }
    if (name) {
        var group = index.get(name);
        if (group)
            return group;
    }
    return undefined;
};
/** The plain text of a note list — for table accessors, search and sorting. */
export var noteTexts = function (notes) { var _a; return (_a = notes === null || notes === void 0 ? void 0 : notes.map(function (note) { var _a; return (_a = note.note) === null || _a === void 0 ? void 0 : _a.trim(); }).filter(function (note) { return !!note; })) !== null && _a !== void 0 ? _a : []; };
